import { render, staticRenderFns } from "./Ficha.vue?vue&type=template&id=bd79edac&scoped=true&"
import script from "./Ficha.vue?vue&type=script&lang=js&"
export * from "./Ficha.vue?vue&type=script&lang=js&"
import style1 from "./Ficha.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd79edac",
  null
  
)

export default component.exports